const RichText = {
  "options": {
    "data": {
      "text": {
        "type": "RichText"
      },
      "images": [
        {
          "to": "",
          "src": ""
        }
      ]
    },
    "customization": {},
    "widgets": {
      "Menu_GeneralSettings": {
        "type": "Menu",
        "order": 1300,
        "renderOptions": {
          "controlKey": "OtherSettings"
        },
        "options": {
          "widget.ToggleRadioTabs_1": {
            "type": "ToggleRadioTabs",
            "order": 14,
            "renderOptions": {
              "controlKey": "backgroundType",
              "direction": "row"
            },
            "options": {
              "backgroundImage": {
                "type": "ImageUploader"
              },
              "backgroundColor": {
                "type": "HexColor"
              }
            }
          },
          "height": {
            "data": {
              "max": 500,
              "min": 0,
              "step": 1
            },
            "type": "RangePx"
          },
          "productTitleMarginBottom": {
            "type": "RangePx",
            "order": 15,
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            }
          },
          "boxShadow": {
            "type": "ChildComponentRenderer",
            "order": 26,
            "data": {
              "componentNames": ["shadow1", "shadow2", "shadow3"]
            }
          }
        }
      }
    }
  },
  "variants": [
    {
      "id": "RichText_1",
      "name": "RichText_1",
      "type": "RichText",
      "data": {
        "text": ""
      },
      "customization": {
        "height": "200px",
        "backgroundColor": "#F0EEFB",
        "backgroundImage": "",
        "backgroundType": "-",
        "containerPadding": "8px 8px 8px 8px"
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/rich_text.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    }
  ]
}

 export default RichText